import { addMoney, getBalance } from "../../api";

const BALANCE_REQUEST = "BALANCE_REQUEST";
const BALANCE_SUCCESS = "BALANCE_SUCCESS";
const BALANCE_FAILURE = "BALANCE_FAILURE";

const state = {
  loading: true,
  error: null,
  balances: {}
};

const getters = {
  isBalanceLoaded (state) {
    return !state.loading && !state.error;
  },
  balances(state) {
    return state.balances
  }
};

const mutations = {
  [BALANCE_REQUEST](state) {
    state.loading = true;
    state.error = null;
    state.amount = null;
  },
  [BALANCE_SUCCESS](state, balances) {
    state.balances = balances.reduce((acc, { currency, balance }) => {
      acc[currency] = balance;
      return acc;
    }, { ...state.balances });
    state.loading = false;
  },
  [BALANCE_FAILURE](state, { error }) {
    state.error = error;
    state.loading = false;
  }
};

const actions = {
  getBalance({ commit }) {
    commit(BALANCE_REQUEST);

    return getBalance().then(
      res => commit(BALANCE_SUCCESS, res.data),
      res => commit(BALANCE_FAILURE, { error: res.data.error })
    );
  },
  addMoney({ commit, state, rootState }, { amount }) {
    const { currency } = rootState.auth;

    return addMoney(amount, currency)
      .then(() =>
        getBalance().then(res => {
          commit(BALANCE_SUCCESS, res.data);
        })
      )
      .catch(e => commit(BALANCE_FAILURE, { error: e }));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
